import styled from 'styled-components'

export const CheckboxLabelStyled = styled.label<{
  htmlFor: string
  disabled?: boolean
}>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
`
